import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Icon } from "@zorni/components-lib";

import styles from "./BookingSteps.module.css";

/**
 * Fil des étapes de la réservation — « 04 - Information ».
 * `current` : 1 Voyage · 2 Informations · 3 Paiement · 4 Confirmation.
 */
const BookingSteps = ({ current = 2 }) => {
  const { t } = useTranslation();

  const steps = [
    t("booking.steps.trip", "Voyage"),
    t("booking.steps.infos", "Informations"),
    t("booking.steps.payment", "Paiement"),
    t("booking.steps.confirmation", "Confirmation"),
  ];

  return (
    <ol className={styles.steps} aria-label={t("booking.steps.aria", "Progression de la réservation")}>
      {steps.map((label, index) => {
        const position = index + 1;
        const done = position < current;
        const now = position === current;

        return (
          <li
            key={label}
            className={`${styles.step} ${done ? styles.done : ""} ${now ? styles.now : ""}`}
            aria-current={now ? "step" : undefined}
          >
            <span className={styles.num}>
              {done ? <Icon name="iconCheck" size="sm" /> : position}
            </span>
            {label}
          </li>
        );
      })}
    </ol>
  );
};

BookingSteps.propTypes = {
  current: PropTypes.oneOf([1, 2, 3, 4]),
};

export default BookingSteps;
